import { createCrudApi } from '@/libs/api/crud'
import {
  ConsolidatedCommCreateResponse,
  ConsolidatedCommunicationPayload,
  ConsolidatedCommunicationUpdateRequest,
} from './types'

export const CONSOLIDATED_COMM_ENDPOINT = '/api/communications/consolidated'

export const consolidatedCommApi = createCrudApi<
  ConsolidatedCommCreateResponse,
  never,
  ConsolidatedCommunicationPayload,
  ConsolidatedCommunicationUpdateRequest
>(CONSOLIDATED_COMM_ENDPOINT)
